import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=9490d3dc&scoped=true&"
import script from "./Receive.vue?vue&type=script&lang=js&"
export * from "./Receive.vue?vue&type=script&lang=js&"
import style0 from "./Receive.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Receive.vue?vue&type=style&index=1&id=9490d3dc&lang=scss&scoped=true&"
import style2 from "./Receive.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9490d3dc",
  null
  
)

export default component.exports